export default __webpack_public_path__ + "static/media/clink.83a7fb11.gif";